import {
  AppContext,
  getTranslatedText,
  IndicatorSeparator,
  DropdownIndicator,
  formatGroupLabel,
  useCurrencySymbols
} from '@nile/components';
import { Label, TextField, Dropdown } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

const HourDropDownWrapper = styled.div`
  display: flex;
  .hour-dropdown {
    max-width: 130px;
    width: 100%;
  }
  .Superops-Dropdown__value-container {
    padding: 0;
  }
`;

/**
 * Section to be rendered for getting  hour type item configuration
 * @public
 */
function HourTypeSection(props) {
  const { company } = useContext(AppContext);
  const currencyCode = company?.currency || 'USD';
  const countryCode = company?.countryCode || 'US';
  const {
    intl,
    serviceItem,
    actions,
    errors,
    handlePropChange,
    subscriptionTypes,
    configurableSections
  } = props;
  const {
    name,
    invoiceDescription,
    category,
    quantity,
    quantityType,
    roundUpValue,
    unitPrice,
    subscriptionType,
    useAsWorklogItem,
    businessHoursUnitPrice,
    afterHoursUnitPrice,
    carryForwardRemainingBlockHours
  } = serviceItem;

  const { currencySymbolWithCode } = useCurrencySymbols();

  const DEFAULT_SERVICE_HOURS = [
    {
      name: 'roundUpValue',
      label: 5,
      value: 5
    },
    {
      name: 'roundUpValue',
      label: 10,
      value: 10
    },
    {
      name: 'roundUpValue',
      label: 15,
      value: 15
    },
    {
      name: 'roundUpValue',
      label: 30,
      value: 30
    }
  ];

  const getServiceItemValue = () => {
    let serviceItemValue = null;
    if (!!roundUpValue || roundUpValue === 0) {
      serviceItemValue = {
        name: 'roundUpValue',
        label: roundUpValue,
        value: roundUpValue
      };
    }

    return serviceItemValue;
  };

  const handleRoundUpValueChange = (val) => {
    if (Number(val) > 0) {
      if (Number(val > 60)) {
        handlePropChange('roundUpValue', 60);
      } else {
        const value = Math.round(Number(val));
        handlePropChange('roundUpValue', value);
      }
    } else {
      handlePropChange('roundUpValue', null);
    }
  };

  return (
    <>
      <div className="mt24">
        <Label>
          <FormattedMessage id="admin.serviceCatalog.withinBusinessHour" />
        </Label>
        <div className="fx actr">
          <TextField
            size="default"
            value={businessHoursUnitPrice}
            min={0}
            type="number"
            onChange={(val) => {
              handlePropChange('businessHoursUnitPrice', val);
            }}
            suffix={currencySymbolWithCode}
          />
        </div>
      </div>
      <div className="mt24">
        <Label>
          <FormattedMessage id="admin.serviceCatalog.afterBusinessHour" />
        </Label>
        <div className="fx actr">
          <TextField
            size="default"
            value={afterHoursUnitPrice}
            min={0}
            type="number"
            onChange={(val) => {
              handlePropChange('afterHoursUnitPrice', val);
            }}
            suffix={currencySymbolWithCode}
          />
        </div>
      </div>
      <div className="mt24">
        <div>
          <Label>
            <FormattedMessage id="admin.serviceCatalog.roundupTime" />
          </Label>
          <HourDropDownWrapper>
            <TextField
              size="default"
              value={
                roundUpValue && roundUpValue > 0
                  ? roundUpValue.toString()
                  : null
              }
              type="number"
              onChange={(val) => {
                handleRoundUpValueChange(val);
              }}
              suffix={getTranslatedText(
                intl,
                'admin.serviceCatalog.roundup.units'
              )}
            />
          </HourDropDownWrapper>
        </div>
      </div>
    </>
  );
}

export default injectIntl(HourTypeSection);
